import { Dictionary } from "../assets/js/contexts";
import "../assets/css/pages/assets.scss";

const ASSETS = [
  
  {
    title: "Black Logo",
    key: "black-logo",
    jpg: true,
  },
  {
    title: "Black Symbol",
    key: "black-symbol",
    jpg: true,
  },
  {
    title: "White Logo",
    key: "white-logo",
    jpg: true,
  },
  {
    title: "White Symbol",
    key: "white-symbol",
    jpg: true,
  },
  {
    title: "White Logo",
    key: "transparent-logo",
  },
  {
    title: "White Symbol",
    key: "transparent-symbol",
  },
];

const Assets = ({ dictionary }) => {
  return (
    <Dictionary.Provider value={dictionary}>
      <div id="assets">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <h1>Media Assets</h1>
              <p className="text-center">
                Fill free to use our brand materials to provide best expirince
                in placment the brand.
              </p>
            </div>
          </div>
          <div className="row mt-5">
            {ASSETS.map((asset) => (
              <div className="col-12 col-lg-6 asset mt-5" key={`asset-${asset.key}`}>
                <img
                  src={`/static/images/assets/${asset.key}/logo.svg`}
                  alt={`logo-${asset.key}`}
                />
                <div>
                  <h4>{asset.title}</h4>
                  <table>
                    <tbody>
                      {[320, 640, 1080].map((resolution) => (
                        <tr key={`resolution-${resolution}`}>
                          <td width="60px">
                            <p>{resolution}px</p>
                          </td>
                          {asset.jpg && (
                            <td>
                              <a
                                href={`/static/images/assets/${asset.key}/${resolution}px.jpg`}
                                target="_blank"
                                download
                                rel="noreferrer"
                              >
                                <img
                                  src="/static/icons/download.svg"
                                  alt="download icon"
                                />
                                JPG
                              </a>
                            </td>
                          )}
                          <td>
                            <a
                              href={`/static/images/assets/${asset.key}/${resolution}px.jpg`}
                              target="_blank"
                              rel="noreferrer"
                              download
                            >
                              <img
                                src="/static/icons/download.svg"
                                alt="download icon"
                              />
                              PNG
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Dictionary.Provider>
  );
};

export default Assets;
